import { useConfig } from 'statsig-react';

interface LinkModifierReturn {
  isConfigActive: boolean;
  statsigLink: unknown;
}

const useLinkModifierConfig = (
  configName: string,
  gen4Enabled: boolean,
  isGen3POP: boolean,
): LinkModifierReturn => {
  const { config: menuLinkConfig } = useConfig(configName);
  const popLinkConfigValue = menuLinkConfig.value;
  const depLink = popLinkConfigValue['oura-dep'];
  const or4POPLink = popLinkConfigValue['oura-ring-4'];
  const gen3POPLink = popLinkConfigValue['oura-gen3'];
  const isConfigActive = Object.keys(popLinkConfigValue).length > 0;

  if (!gen4Enabled) {
    return { isConfigActive, statsigLink: depLink };
  }

  const statsigLink = isGen3POP ? gen3POPLink : or4POPLink;
  return { isConfigActive, statsigLink };
};

export default useLinkModifierConfig;
